// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aa233fd6","455":"cd3656f7","977":"1055f541"}[chunkId] + ".chunk.js";
};